import Vue from "vue";
import Router from "vue-router";

import user, { awaitUserInit } from "@/store/user";

import Billing from "@/views/account/Billing";
import Login from "@/views/account/Login";
import NowPremium from "@/views/account/NowPremium";
import Profile from "@/views/account/Profile";
import Register from "@/views/account/Register";
import Effects from "@/views/calculator/Effects";
import Test from "@/views/calculator/Test";
import Volume from "@/views/calculator/Volume";
import Logs from "@/views/reports/Logs";
import TestHistory from "@/views/reports/Tests";
import Chemicals from "@/views/settings/Chemicals";
import Pools from "@/views/settings/Pools";
import TestSetup from "@/views/settings/TestSetup";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/calculator/",
  routes: [
    {
      path: "/",
      name: "calculator.test",
      component: Test,
    },
    {
      path: "/calculator/effects",
      redirect: "/effects-calculator",
    },
    {
      path: "/effects-calculator",
      name: "calculator.effects",
      component: Effects,
    },
    {
      path: "/calculator/volume",
      redirect: "/volume-calculator",
    },
    {
      path: "/volume-calculator",
      name: "calculator.volume",
      component: Volume,
    },
    {
      path: "/reports/logs",
      name: "reports.logs",
      component: Logs,
      meta: {
        requiresAuth: true,
        requiresPremium: true,
      },
    },
    {
      path: "/reports/tests",
      name: "reports.tests",
      component: TestHistory,
      meta: {
        requiresAuth: true,
        requiresPremium: true,
      },
    },
    {
      path: "/account/billing",
      name: "account.billing",
      component: Billing,
      meta: {
        requiresAuth: true,
        requiresPremium: false,
      },
    },
    {
      path: "/account/billing/nowPremium",
      name: "account.billing.nowPremium",
      component: NowPremium,
      meta: {
        requiresAuth: true,
        requiresPremium: true,
      },
    },
    {
      path: "/account/login",
      name: "account.login",
      component: Login,
    },
    {
      path: "/account/profile",
      name: "account.profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        requiresPremium: false,
      },
    },
    {
      path: "/account/register",
      name: "account.register",
      component: Register,
    },
    {
      path: "/settings/chemicals",
      name: "settings.chemicals",
      component: Chemicals,
      meta: {
        requiresAuth: true,
        requiresPremium: true,
      },
    },
    {
      path: "/settings/pools",
      name: "settings.pools",
      component: Pools,
      meta: {
        requiresAuth: true,
        requiresPremium: false,
      },
    },
    {
      path: "/settings/test",
      name: "settings.test",
      component: TestSetup,
      meta: {
        requiresAuth: true,
        requiresPremium: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  awaitUserInit().then(() => {
    var isPremium = user.state.premium;
    const isLoggedIn = !!user.state.email;
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const requiresPremium = to.matched.some((x) => x.meta.requiresPremium);

    if (requiresPremium && !isPremium) {
      next("/account/billing");
    } else if (requiresAuth && !isLoggedIn) {
      next("/account/login");
    } else {
      next();
    }
  });
});

export default router;
